import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import {
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledButtonDropdown, Input,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import {
  staticConstants, capitalizeEveryWord, FALLBACK_ICON, NUMERIC_VALUE, formatedCurrency,
} from '../../../utils';

function ArtistItemList(props) {
  const {
    item, currentIndex, fetchedProfileImage, registerDate, toggleDeactivateModal, toggleDeleteModal, toggleEditArtistModal,
    toggleRequestModal, submitNote, updateItem,
  } = props;
  const [noteValue, setNoteValue] = useState('');
  const [defaultNoteValue, setDefaultNoteValue] = useState('');

  useEffect(() => {
    if (item && item.note) {
      setNoteValue(item.note);
      setDefaultNoteValue(item.note);
    }
    updateItem(item, fetchedProfileImage);
  }, [item]);

  const onSubmit = () => {
    const reqObj = {
      userId: item._id,
      note: noteValue,
    };
    submitNote(reqObj);
    setDefaultNoteValue(noteValue);
  };

  const handleClearInput = () => {
    setNoteValue('');
  };

  const openNotePopup = () => {
    setNoteValue(defaultNoteValue);
  };

  return (
    <div
      className={`d-flex-table-row ${(item.status === staticConstants.STATUS_TYPE.DEACTIVATED || item.isDelete) ? 'disabled-row' : ''}`}
      key={`${item.createdAt}-${currentIndex}`}
    >
      <div
        className={`d-flex-table-col  d-flex-table-col-13 ${item.status === staticConstants.STATUS_TYPE.ACTIVE && 'cursor-pointer'}`}
        onClick={() => { item.status === staticConstants.STATUS_TYPE.ACTIVE && props.toggleArtistDetailModal(item, fetchedProfileImage); }}
      >
        <span className="user-name-col">
          <em className="d-flex-table-col-user-img">
            <ReactImageFallback
              src={fetchedProfileImage}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
              alt="User"
            />
          </em>
          <em
            className="user-name"
            data-tip={capitalizeEveryWord(item.name)}
            data-place="bottom"
            data-background-color="#fff"
            data-text-color="#000"
          >
            {capitalizeEveryWord(item.name)}
          </em>
          <ReactTooltip effect="solid" />
        </span>
      </div>
      <div className="d-flex-table-col d-flex-table-col-16">
        <span
          className="user-name"
          data-tip={item.email}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {item.email || (item.managerData && item.managerData.email)}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-10">
        <span
          className="user-name"
          data-tip={item.contactNumber}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {item.contactNumber}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-10">
        <span
          className="user-name"
          data-tip={item && item.city && item.city.label}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {item && item.city && item.city.label}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-10">
        <span
          className="user-name"
          data-tip={`${item && item.managerData && capitalizeEveryWord(item.managerData.managerFirstName)}
            ${item && item.managerData && capitalizeEveryWord(item.managerData.managerLastName)}`}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {' '}
          {item.managerData
            ? capitalizeEveryWord(`${item.managerData.managerFirstName} ${item.managerData.managerLastName}`)
            : '--'}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-11"><span>{registerDate}</span></div>
      <div className="d-flex-table-col d-flex-table-col-11">
        { item.isDelete
          ? (
            <span className="status-text">
              {' '}
              {staticConstants.STATUS_NAME.deleted}
              {' '}
            </span>
          )
          : (
            <span
              className={`status-text ${item.status === staticConstants.STATUS_TYPE.REQUESTED && 'requested'}
         ${item.status === staticConstants.STATUS_TYPE.REJECTED && 'rejected'}`}
              onClick={() => { item.status === staticConstants.STATUS_TYPE.REQUESTED && toggleRequestModal(item); }}
            >
              {staticConstants.STATUS_NAME[item.status]}
            </span>
          )}
      </div>
      <div className="d-flex-table-col d-flex-table-col-9"><span>{`$${formatedCurrency(item.totalRevenue)}`}</span></div>
      <div className="d-flex-table-col d-flex-table-col-10">
        <span className="note-icon-col">
          {item.totalOffer}
          {!item.isDelete
          && (
          <>
            <UncontrolledButtonDropdown className="note-dropdown-toggle">
              <DropdownToggle>
                <em
                  className={`note-icon ${item.note ? 'yellow-card' : 'gray-card'}`}
                  onClick={() => openNotePopup()}
                />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme note-dropdown">
                <div className="dropdown-header">
                  Note for admin
                  <DropdownItem>
                    <span className="icon icon-cross" />
                  </DropdownItem>
                </div>
                <Input
                  type="textarea"
                  className="medium"
                  name="note"
                  maxLength={NUMERIC_VALUE.FIVE_HUNDRED}
                  value={noteValue}
                  onChange={(e) => setNoteValue(e.target.value)}
                />
                <div className="dropdown-footer">
                  <span onClick={() => handleClearInput()}>Clear</span>
                  <DropdownItem
                    className="btn btn-save"
                    onClick={() => onSubmit()}
                  >
                    Save
                  </DropdownItem>
                </div>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
            <UncontrolledButtonDropdown className="action-dropdown-toggle">
              <DropdownToggle>
                <span className="table-toggle ml-auto mr-1" />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme action-dropdown white-space-none">

                {
                item.status === staticConstants.STATUS_TYPE.REQUESTED && (
                  <>
                    <DropdownItem onClick={() => { toggleRequestModal(item); }}>Accept request</DropdownItem>
                    <DropdownItem onClick={() => { toggleRequestModal(item); }}>Reject request</DropdownItem>
                  </>
                )
              }
                {
                item.status === staticConstants.STATUS_TYPE.REJECTED && item.rejectReason && (
                  <>
                    <p className="reject-message">{`${item.rejectReason.preDefined} ${item.rejectReason.custom}`}</p>
                  </>
                )
              }
                {(item.status === staticConstants.STATUS_TYPE.ACTIVE || item.status === staticConstants.STATUS_TYPE.DEACTIVATED) && (
                <>
                  {
                  item.status === staticConstants.STATUS_TYPE.ACTIVE
                  && <DropdownItem onClick={() => { toggleEditArtistModal(item); }}>Update Artist info</DropdownItem>
                }
                  <DropdownItem onClick={() => { props.toggleArtistDetailModal(item, fetchedProfileImage); }}>
                    View demographics
                  </DropdownItem>
                </>
                )}
                {/* {
                (item.status === staticConstants.STATUS_TYPE.ACTIVE || item.status === staticConstants.STATUS_TYPE.DEACTIVATED) && (
                <>
                  {
                        item.status === staticConstants.STATUS_TYPE.ACTIVE
                        && <DropdownItem onClick={() => { toggleEditArtistModal(item); }}>Update Artist info</DropdownItem>
                      }
                  <DropdownItem onClick={() => { props.toggleArtistDetailModal(item, fetchedProfileImage); }}>
                    View demographics
                  </DropdownItem>
                </>
                )
              } */}
                <DropdownItem
                  className={item.status === staticConstants.STATUS_TYPE.ACTIVE ? 'item-text-red' : ''}
                  onClick={() => { toggleDeleteModal(item); }}
                >
                  Delete account
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </>
          )}
        </span>
      </div>
    </div>
  );
}
ArtistItemList.propTypes = {
  item: PropTypes.object.isRequired,
  currentIndex: PropTypes.number.isRequired,
  fetchedProfileImage: PropTypes.string,
  registerDate: PropTypes.string.isRequired,
  toggleRequestModal: PropTypes.func.isRequired,
  toggleDeactivateModal: PropTypes.func.isRequired,
  toggleDeleteModal: PropTypes.func.isRequired,
  toggleEditArtistModal: PropTypes.func.isRequired,
  submitNote: PropTypes.func.isRequired,
  toggleArtistDetailModal: PropTypes.func.isRequired,
  updateItem: PropTypes.func,
};

ArtistItemList.defaultProps = {
  updateItem: null,
  fetchedProfileImage: null,
};

export default React.memo(ArtistItemList);
